import React from "react";
import Select from "react-select";
import styled from "styled-components";

const StyledItem = styled.div``;

export default function MySelect({ options, placeholder, onChange }) {
  return (
    <StyledItem>
      <Select
        classNames={{
          control: () => `rounded-3 `,
        }}
        options={options}
        placeholder={placeholder}
        onChange={onChange}
      />
    </StyledItem>
  );
}
